// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"style_cardTitle__252Bz"};